import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`About`}</h2>
    <blockquote>
      <p parentName="blockquote">{`Full Stack Developer - Graduated from Concordia University. `}</p>
    </blockquote>
    <p>{`I have two years experience creating web apps, software, and websites for both myself, and for clients. I have experience programming in many different languages such as Java, JavaScript.`}</p>
    <p>{`I am interested in creating wed services and mobile application! Great passion to learn and explore.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      